import { NAME } from './constants';

export const LOAD_BY_DEPARTURE_AIRPORT_CARRIER_AND_DATE = `${NAME}/LOAD_BY_DEPARTURE_AIRPORT_CARRIER_AND_DATE`;
export const LOAD_BY_ARRIVAL_AIRPORT_CARRIER_AND_DATE = `${NAME}/LOAD_BY_ARRIVAL_AIRPORT_CARRIER_AND_DATE`;
export const LOAD_BY_ROUTE_CARRIER_AND_DATE = `${NAME}/LOAD_BY_ROUTE_CARRIER_AND_DATE`;
export const LOAD_SUCCESS = `${NAME}/LOAD_SUCCESS`;
export const LOAD_FAIL = `${NAME}/LOAD_FAIL`;
export const UPDATE_PAGE_INDEX = `${NAME}/UPDATE_PAGE_INDEX`;
export const UPDATE_LOADED = `${NAME}/UPDATE_LOADED`;



// WEBPACK FOOTER //
// ./modules/MultiFlight/redux/actionTypes.js